/* */
import {
  Stack,
  Text,
  Grid,
  Group,
  Center,
  Switch,
  Accordion,
} from "@mantine/core";
import { IconSortAscending2, IconSortDescending2 } from "@tabler/icons";
import { useState } from "react";
import EthAddress from "../EthAddress/EthAddress";
import NickName from "../EthAddress/NickName";
import RegionToText from "../RegionInfo/RegionToText";
import "./styles.css";

export default function FlippedTable(props) {
  const [showOnline, setShowOnline] = useState(true);
  const sortedTranscoders = props.transcoderInfo;
  let sign = <IconSortDescending2 size={18} color={"#86c232"} />;
  if (props.ascending) {
    sign = <IconSortAscending2 size={18} color={"#86c232"} />;
  }
  return (
    <Stack spacing={24} sx={{ width: "100%" }}>
      <Group position="apart" spacing={0}>
        <Text size="xl" fw={700}>
          Pool Transcoders - {props.poolInfo.sessionSum}/
          {props.poolInfo.capacitySum} capacity
        </Text>
        <Switch
          checked={showOnline}
          onChange={(event) => setShowOnline(event.currentTarget.checked)}
          onLabel="Online"
          offLabel="All"
          color="#86c232"
          styles={{
            root: {
              display: "table-cell",
              verticalAlign: "middle",
            },
            body: {
              display: "block",
            },
          }}
          radius="sm"
          size="xl"
        />
      </Group>
      <Group spacing="14px">
        <Text size="md">Sort by:</Text>
        <Group>
          <Text className="hover" onClick={() => props.setSort("address")}>
            Address
          </Text>
          {props.sorting == "address" ? <Center>{sign}</Center> : null}
        </Group>
        <Group>
          <Text className="hover" onClick={() => props.setSort("sessionSum")}>
            Sessions
          </Text>
          {props.sorting == "sessionSum" ? <Center>{sign}</Center> : null}
        </Group>
        <Group>
          <Text
            className="hover"
            onClick={() => props.setSort("pendingSinceLastTicket")}
          >
            Share
          </Text>
          {props.sorting == "pendingSinceLastTicket" ? (
            <Center>{sign}</Center>
          ) : null}
        </Group>
      </Group>
      <Accordion
        variant="filled"
        styles={{
          item: {
            "&[data-active]": {
              backgroundColor: "#36393f",
            },
          },
        }}
      >
        {sortedTranscoders.map(function (item, idx) {
          let emphasize = false;
          if (props.selectedAddress == item.address) {
            emphasize = true;
          }
          let isConnected = false;
          for (const region of item.regions) {
            if (region.capacity || region.sessions) {
              isConnected = true;
              break;
            }
          }
          if (!isConnected && showOnline) {
            return null;
          }
          const thisPP = (
            parseFloat(
              item.pendingSinceLastTicket /
                props.poolInfo.pendingSinceLastTicketSum
            ) * 100
          ).toFixed(1);
          return (
            <Accordion.Item value={item.address} key={"transcoder-" + idx}>
              <Accordion.Control>
                <Grid
                  columns={12}
                  sx={{
                    borderBottom: "1px solid rgba(107, 110, 112, 0.25)",
                    borderTop: "1px solid rgba(107, 110, 112, 0.25)",
                    borderRadius: "7px",
                  }}
                >
                  <Grid.Col span={3}>
                    <Text>Address</Text>
                  </Grid.Col>
                  <Grid.Col span={9}>
                    {item.nickname != item.address ? (
                      <NickName
                        address={item.address}
                        nickname={item.nickname}
                        selectTranscoder={
                          emphasize ? null : props.selectTranscoder
                        }
                        emphasize={emphasize}
                      />
                    ) : (
                      <EthAddress
                        address={item.address}
                        selectTranscoder={
                          emphasize ? null : props.selectTranscoder
                        }
                        emphasize={emphasize}
                        cachedENS={props.cachedENS}
                      />
                    )}
                  </Grid.Col>
                </Grid>
                <Grid columns={12}>
                  <Grid.Col span={6}>
                    <Text>Sessions</Text>
                  </Grid.Col>
                  <Grid.Col span={6}>{item.sessionSum}</Grid.Col>
                </Grid>
                <Grid columns={12}>
                  <Grid.Col span={6}>
                    <Text>Share</Text>
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Group>
                      <Text
                        sx={{
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {thisPP} %
                      </Text>
                    </Group>
                  </Grid.Col>
                </Grid>
              </Accordion.Control>
              <Accordion.Panel>
                {isConnected ? (
                  <Stack spacing={12}>
                    <Grid columns={9}>
                      <Grid.Col span={3}>
                        <Text>Region</Text>
                      </Grid.Col>
                      <Grid.Col span={3}>
                        <Text>Capacity</Text>
                      </Grid.Col>
                      <Grid.Col span={3}>
                        <Text>Sessions</Text>
                      </Grid.Col>
                    </Grid>
                    <Stack spacing={0}>
                      {item.regions.map(function (region, idx) {
                        if (!region.capacity && !region.sessions) {
                          return;
                        }
                        return (
                          <Grid columns={9} key={item.address + idx}>
                            <Grid.Col span={3}>
                              <RegionToText
                                orchestratorName={region.orchestratorName}
                                orchestratorRegion={region.orchestratorRegion}
                              />
                            </Grid.Col>
                            <Grid.Col span={3}>
                              <Text>{region.capacity}</Text>
                            </Grid.Col>
                            <Grid.Col span={3}>
                              <Text>{region.sessions}</Text>
                            </Grid.Col>
                          </Grid>
                        );
                      })}
                    </Stack>
                  </Stack>
                ) : null}
              </Accordion.Panel>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </Stack>
  );
}
